export default __webpack_public_path__ + "static/media/lifebuoy.ab181952.svg";